import axiosSmartSurvey from '../../../api/axios'
import useAuth from '../../../hooks/useAuth'

export default function useTrackDoc() {
    const { user } = useAuth()

    async function fetchAndAppendFolderData(parcelCode, docData, setDocData, setOpenError, setErrorText) {
        try {
            const response = await axiosSmartSurvey({
                method: 'post',
                url: '/trackdoc/folderdata',
                data: { parcelCode }
            });
            addTransection(parcelCode, "fetchAndAppendFolderData", `ดึงข้อมูลซอง ${user.fName + " " + user.lName}`)
            const folderData = response.data.folderData;
            setDocData([
                ...docData,
                {
                    id: folderData.id,
                    parcelCode: folderData.parcel_code,
                    dn: folderData.dn,
                    oldParcel: folderData.old_parcel,
                    holder: folderData.holder,
                    recievedDate: folderData.recieved_date,
                    fname: folderData.fname,
                    lname: folderData.lname
                }
            ]);
        } catch (err) {
            setOpenError(true)
            setErrorText(err.response.data.message)
            // console.error('Error fetching folder data:', err);
        }
    }
    async function fetchSingleFolderData(parcelCode, setDoc, setOpenError, setErrorText) {
        try {
            const response = await axiosSmartSurvey({
                method: 'post',
                url: '/trackdoc/folderdata',
                data: { parcelCode }
            });
            addTransection(parcelCode, "fetchSingleFolderData", `ค้นหาข้อมูลซองโดย ${user.fName + " " + user.lName}`)
            const folderData = response.data.folderData;
            setDoc({
                id: folderData.id,
                parcelCode: folderData.parcel_code,
                dn: folderData.dn,
                oldParcel: folderData.old_parcel,
                holder: folderData.holder,
                recievedDate: folderData.recieved_date,
                fname: folderData.fname,
                lname: folderData.lname,
                parcelTypeName: folderData.type_name,
                gid: folderData.gid,
            });
        } catch (err) {
            setOpenError(true)
            setErrorText(err.response.data.message)
            // console.error('Error fetching folder data:', err);
        }
    }
    async function updateCurrentHolder(docData, setOpenSuccess, setOpenError, setSuccessText, setErrorText) {
        try {
            const response = await axiosSmartSurvey({
                method: 'post',
                url: '/trackdoc/updatecurrentholder',
                data: {
                    docData: docData,
                    userId: user.userId
                }
            });
            await docData.forEach(data => {
                addTransection(data.parcelCode, "holder_update", `เปลี่ยนผู้ถือครองเป็น${user.fName + " " + user.lName}`)
            });
            const status = response.status
            console.log(response)
            if (status === 200) {
                setOpenSuccess(true)
                setSuccessText('รับซองสำเร็จ')
            }
        } catch (err) {
            setOpenError(true)
            setErrorText('รับซองไม่สำเร็จ')
        }
    }
    async function returnDoc(docData, setOpenSuccess, setOpenError, setSuccessText, setErrorText) {
        try {
            const response = await axiosSmartSurvey({
                method: 'post',
                url: '/trackdoc/updatecurrentholder',
                data: {
                    docData: docData,
                    userId: 0
                }
            });
            await docData.forEach(data => {
                addTransection(data.parcelCode, "returnDoc", `เก็บเข้าแฟ้มโดย${user.fName + " " + user.lName}`)
            });
            const status = response.status
            if (status === 200) {
                setOpenSuccess(true)
                setSuccessText('เก็บเข้าแฟ้มสำเร็จ')
            }
        } catch (err) {
            setOpenError(true)
            setErrorText('เก็บเข้าแฟ้มไม่สำเร็จ')
            console.error('เกิดข้อผิดพลาดในการอัปเดตผู้ถือครอง:', err);
        }
    }
    async function addFolder(modalForm, setOpenSuccess, setOpenError, setSuccessText, setErrorText) {
        try {
            const response = await axiosSmartSurvey({
                method: 'post',
                url: '/trackdoc/addfolder',
                data: {
                    modalForm: modalForm,
                    userId: user.userId
                }
            });
            console.log(response)
            const { parcelCode } = modalForm
            addTransection(parcelCode, 'addFolder', `เพิ่มซองโดย${user.fName + " " + user.lName}`)
            const status = response.status
            if (status === 200) {
                setOpenSuccess(true)
                setSuccessText('เพิ่มซองสำเร็จ')
            }
        } catch (err) {
            console.log(err)
            setOpenError(true)
            setErrorText(err.response.data.message)
        }
    }

    async function addTransection(parcelCode, actionType, description) {
        console.log(parcelCode, actionType, description)
        try {
            const response = await axiosSmartSurvey.post('/trackdoc/logtransaction', {
                parcelCode: parcelCode,
                actionType: actionType,
                description: description,
                userId: user.userId
            });
            console.log('เก็บทรานเซ็คชั่นสำเร็จ:', response.data);
        } catch (err) {
            console.error('เกิดข้อผิดพลาดเก็บทรานเซ็คชั่น', err);
        }
    }


    return { fetchAndAppendFolderData, fetchSingleFolderData, updateCurrentHolder, returnDoc, addFolder }
}
